import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";
import SevenAMonthwiseReport from "./SevenAMonthwiseReport";

const WagonYearWiseChartUpdate = ({
  chartData,
  setChartData,
  data,
  setSummery,
  targetData,
  setTargetData,
}) => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  // const [targetData, setTargetData] = useState([]);
  // Function to fetch target data for the greatest year
  const fetchTargetData = async (year) => {
    try {
      const response = await fetch(
        `${urlPrefix}data7a_monthwise_target?finYears=${year}`, // Use dynamic year
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      console.log(result);
      setTargetData(result.tgtdata7A || []);
    } catch (error) {
      console.error("Error fetching target data:", error);
      setTargetData([]);
    }
  };

  function transformYearlyData(data, targetData) {
    const allYearKeys = new Set();
    const groupMap = {};
    let greatestYear = null;

    // Step 1: Identify all years and find the greatest year
    data.forEach((yearEntry) => {
      const year = yearEntry.F_YEAR; // e.g., "2025_26"
      allYearKeys.add(year);
      if (!greatestYear || year > greatestYear) {
        greatestYear = year; // Update greatest year
      }
    });

    // Step 2: Process data, including target for the greatest year
    data.forEach((yearEntry) => {
      const year = yearEntry.F_YEAR;
      const yearKey = year;
      const isGreatestYear = year === greatestYear;
      const yearTargetKey = `${year}_target`;

      // Only add the target key for the greatest year
      if (isGreatestYear) {
        allYearKeys.add(yearTargetKey);
      }

      yearEntry.commodities_data.forEach((group) => {
        const groupKey = group.GROUP_COMMODITY;
        if (!groupMap[groupKey]) groupMap[groupKey] = { product: groupKey };

        // Initialize totals
        let yearWagonTotal = 0;
        let yearTargetTotal = 0;

        // Collect unique months for WAGON calculation
        const uniqueMonths = new Set();
        const monthTargetMap = {}; // To store month-wise targets for this commodity

        group.group_commodities_data.forEach((subGroup) => {
          subGroup.sub_commodities_data.forEach((commodity) => {
            commodity.months_data.forEach((monthEntry) => {
              const month = monthEntry.A_MONTH; // e.g., "Apr"
              uniqueMonths.add(month); // Track unique months

              // --- WAGON sum ---
              const wagonSum = monthEntry.data.reduce(
                (sum, d) => sum + parseFloat(d.WAGON || 0),
                0,
              );
              yearWagonTotal += wagonSum;

              // --- Target from API for the greatest year ---
              if (isGreatestYear && targetData && targetData.length > 0) {
                const normalizedMonth = month.trim().toUpperCase();
                const normalizedGroupKey = groupKey.trim().toUpperCase();

                // Find matching target data
                const targetEntry = targetData.find((t) => {
                  const normalizedTargetMonth = t.month.trim().toUpperCase();
                  const normalizedTargetCommodity = t.commodity
                    .trim()
                    .toUpperCase();
                  return (
                    t.f_year === year &&
                    normalizedTargetMonth === normalizedMonth &&
                    normalizedTargetCommodity === normalizedGroupKey
                  );
                });

                if (targetEntry && !monthTargetMap[month]) {
                  monthTargetMap[month] = parseFloat(targetEntry.tgt_wgn || 0);
                } else if (!targetEntry) {
                }
              }
            });
          });
        });

        // Sum the month-wise targets for the greatest year
        if (isGreatestYear) {
          yearTargetTotal = Object.values(monthTargetMap).reduce(
            (sum, tgt) => sum + tgt,
            0,
          );
        }

        // Store values
        groupMap[groupKey][yearKey] = yearWagonTotal.toFixed(2);
        if (isGreatestYear) {
          groupMap[groupKey][yearTargetKey] = yearTargetTotal.toFixed(2);
        }
      });
    });

    // Step 3: Create dimensions and series
    const dimensions = ["product", ...Array.from(allYearKeys).sort()];
    let series = Object.values(groupMap);

    // Step 4: Sort series by the greatest year's target in descending order
    const targetKey = `${greatestYear}_target`;
    series.sort((a, b) => {
      const targetA = parseFloat(a[targetKey] || 0);
      const targetB = parseFloat(b[targetKey] || 0);
      return targetB - targetA; // Descending order
    });

    return { dimensions, series };
  }

  useEffect(() => {
    if (data && data.length > 0) {
      // Find the greatest year
      let greatestYear = null;
      data.forEach((yearEntry) => {
        const year = yearEntry.F_YEAR;
        if (!greatestYear || year > greatestYear) {
          greatestYear = year;
        }
      });

      // Fetch target data for the greatest year
      fetchTargetData(greatestYear); // Use dynamic greatest year
    }
  }, [data]);

  useEffect(() => {
    if (data && data.length > 0 && targetData) {
      const calChartData = transformYearlyData(data, targetData);
      setChartData(calChartData);
      setSummery((prev) => ({ ...prev, commodityWise: calChartData }));
    }
  }, [data, targetData]);

  return (
    <div>
      <h6 className="m-1 p-2 bg-dark text-white">7A Loading Commodity Wise</h6>
      {chartData ? (
        <GroupedBarChart
          data={chartData}
          from="7ALoading"
          chartType="bar"
          // trend={true}
        />
      ) : (
        "No Data Found"
      )}
      <b style={{ color: "gray", fontSize: "12px" }}>
        {" "}
        target data does not update as per the selection of the stations{" "}
      </b>
    </div>
  );
};

export default WagonYearWiseChartUpdate;
